<div class="apg-panel">
  <div class="apg-loading" *ngIf="loading">
    <p>Processing...</p>
    <ion-spinner></ion-spinner>
  </div>

  <ng-container [ngSwitch]="mode" *ngIf="!loading">

    <ng-container *ngSwitchCase="'form'">
      <form name="verifyForm" #verifyForm="ngForm" class="page" *ngIf="page" [appScrollIntoView]="page">
        <div class="title" *ngIf="page.showHeader">{{page.title}}</div>

        <div class="cube">
          <div class="filler"></div>

          <div class="questions">
            <ng-container *ngFor="let question of page.questions">
              <div *ngIf="question.visible" class="question">
                <div class="separator" *ngIf="question.type === 'ImageSelect'"></div>
                <app-question [question]="question"
                              [showHeader]="page.questions.length &gt; 1 || page.questions.length === 1 "></app-question>
              </div>
            </ng-container>

            <div class="summary__buttons" buttons>
              <ion-button (click)="back.emit()">Start a new quote</ion-button>

              <ion-button (click)="verifyForm.form.valid && next()" [disabled]="verifyForm.invalid || errorKey">
                Find Quote
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </ion-button>
            </div>

            <app-site-content [key]="errorKey" class="invalid-feedback d-block" *ngIf="errorKey"></app-site-content>
          </div>

          <div class="line"></div>
        </div>
      </form>
    </ng-container>

    <app-otp *ngSwitchCase="'otp'" [email]="questionnaire.answersObject.Email" [otpKey]="otpKey" [title]="page.title"
             (next)="saveOtp($event)" (back)="mode = 'form'">
    </app-otp>

    <div *ngSwitchCase="'list-quotes'" class="list-quotes">
      <div *ngIf="!quotes.length">
        <p>
          No quotes found
        </p>

        <div class="summary__buttons" buttons>
          <ion-button (click)="back.emit()">Start a new quote</ion-button>
        </div>
      </div>

      <div *ngIf="quotes.length">

        <div class=" list-title">Multiple Quotes Found</div>
        <p>We have found the following quotes for you, please select one below to continue or start a new quote.</p>
        <div class="summary__buttons" buttons>
          <ion-button (click)="back.emit()">Start a new quote</ion-button>
        </div>

        <div class="quote" *ngFor="let quote of quotes">

          <div class="quote-title">
            {{quote.describe()}}
            <small *ngIf="quote.policyType == 'TERM-CI'">
              with Critical Illness Cover
            </small>
          </div>
          <div class="details">
            Ref: {{quote.quoteNo}}<br />
            Date: {{quote.date | date:'d MMM yyyy'}}<br />
            Term: {{quote.term}} years<br />
            Life Cover: <b>{{quote.answer('ProtectionLevel_1') | pounds}}</b><br />
            <div *ngIf="quote.policyType == 'TERM-CI'">
              Critical Illness Cover: <b>{{quote.answer('ProtectionLevel_2') | pounds}}</b>
            </div>
          </div>

          <div class="premium">
            <div class="amount">
              {{quote.premium | pounds}}<small>{{quote.premium | appcents}}/month</small>
            </div>
          </div>

          <div class="summary__buttons">
            <ion-button class="app-button" (click)="loaded.emit(quote.quote)">
              Select
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </ion-button>
          </div>

        </div>

        <div *ngIf="loadNextQuotes" appInView (inView)="loadMoreQuotes()" style="height:10px;">
        </div>

        <div *ngIf="loadingQuotes">
          <ion-spinner></ion-spinner>
          Loading...
        </div>
      </div>
    </div>
  </ng-container>
</div>